import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
  reducer: {
    // We'll add reducers here later
  },
});

export default store;
